import { userHasConsentedToCookieCategoryWithKey } from 'src/cookies/consent-cookie';

const socialMediaConsentCookieCategoryKey = 'social_media';

export const userHasConsentedToSocialMediaCookieCategory = (): boolean =>
  userHasConsentedToCookieCategoryWithKey(socialMediaConsentCookieCategoryKey);
